// Migrated from app/assets/javascripts/admin.js.erb
// Admin inline code: datepickers, CKEditor init, utility functions

import 'jquery'
import calendarIcon from '@images/admin/icons/calendar.png'
import timeIcon from '@images/admin/icons/time.png'

$(function () {
    $('[data-toggle="tooltip"]').tooltip()

    // CKEditor init (CKEditor 4 loaded via separate script tag in layout)
    if (typeof CKEDITOR !== 'undefined') {
      CKEDITOR.disableAutoInline = true;
      CKEDITOR.config.versionCheck = false;
      $("textarea.ckeditor-simple").each(function (index) {
          CKEDITOR.inline(
              $(this).attr('id'), {
                  'uiColor': '#bbd6ff',
                  'toolbar': 'avayo_mini'
              }
          );
      });

      $("textarea.ckeditor-enriched").each(function (index) {
          CKEDITOR.inline(
              $(this).attr('id'), {
                  'uiColor': '#bbd6ff',
                  'toolbar': 'avayo_mini2'
              }
          );
      });
    }

    $('input.datepicker').datepicker({
            dateFormat: 'dd-mm-yy',
            changeMonth: true,
            changeYear: true,
            showOn: 'both',
            buttonImage: calendarIcon,
            buttonImageOnly: true
        },
        $.datepicker.regional.nl);

    $('input.datetimepicker').datetimepicker({
        showOn: 'both',
        buttonImage: calendarIcon,
        buttonImageOnly: true
    });

    $('input.datetimepicker_only_future').datetimepicker({
        minDate: new Date(),
        showOn: 'both',
        buttonImage: calendarIcon,
        buttonImageOnly: true
    });

    $('input.timepicker').timepicker({
            hourMin: 0,
            hourMax: 23,
            showOn: 'both',
            buttonImage: timeIcon,
            buttonImageOnly: true
        },
        $.datepicker.regional.nl);
    $('input.timepicker').timepicker();

    $(".best_in_place").best_in_place();
    $("a[rel^='prettyPhoto']").prettyPhoto({social_tools: ''});

    $("a.preventDoubleClick").one("click", function () {
        $(this).click(function () {
            return false;
        });
    });
});

// limit input on textarea with counter
(function ($) {
    $.fn.extend({
        limiter: function (limit, elem) {
            $(this).on("keyup focus", function () {
                setCount(this, elem);
            });

            function setCount(src, elem) {
                var chars = src.value.length;
                if (chars > limit) {
                    src.value = src.value.substr(0, limit);
                    chars = limit;
                }
                elem.html(limit - chars);
            }

            setCount($(this)[0], elem);
        }
    });
})(jQuery);

window.toggleShowItem = function(checkbox, targetClass) {
  const checked = $(checkbox).is(':checked');
  $('.' + targetClass).toggle(checked);
}

window.toggleAttrDisabled = function(checkbox, targetClass) {
  const disabled = $(checkbox).is(':checked');
  if (disabled) {
    $('.' + targetClass).removeAttr('disabled');
  } else {
    $('.' + targetClass).attr('disabled', 'disabled');
  }
}

window.copy_clipboard = function(id) {
    var copyTextElm = document.getElementById(id);
    copyTextElm.focus();
    copyTextElm.select();
    document.execCommand("copy");
    alert("Reseller link gekopieerd naar het klembord.");
}

// AT-1700: kopieer de boekingslink op de evenementpagina (admin/events/_booking_link).
window.copy_booking_link = function(button) {
    var url = button.dataset.url;
    var done = function() {
        if (window.toastr) {
            toastr.success('Boekingslink gekopieerd naar het klembord');
        }
    };
    if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(done);
    } else {
        var field = button.closest('.booking-link').querySelector('.booking-link__url');
        field.select();
        document.execCommand('copy');
        done();
    }
}

// helpers
window.remove_fields = function(link) {
    var remove_element = $(link).closest(".group");
    var group_elm = $(link).closest(".group");
    if (group_elm.hasClass("category")) {
        do {
            group_elm.hide();
            group_elm.find("[id$='discarded_at']").val(new Date(Date.now()));
            group_elm = group_elm.next();
        }
        while (!group_elm.hasClass("category"));
    } else {
        group_elm.hide();
        group_elm.find("[id$='discarded_at']").val(new Date(Date.now()));
    }
}

window.add_fields = function(link, association, content) {
    var new_id = new Date().getTime();
    var regexp = new RegExp("new_" + association, "g");
    var html = $.parseHTML(content.replace(regexp, new_id));

    var remove_group_link = $(html).find("a.remove_fields");
    remove_group_link.click(function () {
        remove_fields(remove_group_link);
    });

    var add_product_link = $(html).find("a.add_fields");
    add_product_link.click(function () {
        add_fields(add_product_link, add_product_link.data('association'), add_product_link.data('fields'));
    });

    $(link).closest(".group").before(html);
}

// Dropdown menu functionality for ticket downloads
$(document).on('click', '.dropdown-toggle', function(e) {
    e.preventDefault();
    e.stopPropagation();
    var $parent = $(this).closest('.btn-group');

    // Close all other open dropdowns
    $('.btn-group').not($parent).removeClass('open');

    // Toggle this dropdown
    $parent.toggleClass('open');
});

// Close dropdown when clicking outside
$(document).on('click', function(e) {
    if (!$(e.target).closest('.btn-group').length) {
        $('.btn-group').removeClass('open');
    }
});

// Prevent dropdown from closing when clicking inside
$(document).on('click', '.btn-group .dropdown-menu', function(e) {
    e.stopPropagation();
});
